import React from "react"
import { RouteComponentProps } from "@reach/router"
import { Navigation } from "../../components"
import { becomeSpecialistText, gainText, details } from "./text.json"
import logo from "../../components/Navigation/logo.svg"
import check from "../../../assets/icons/check.svg"
import talent1 from "../../../assets/icons/talent1.png"
import talent2 from "../../../assets/icons/talent2.png"
import talent3 from "../../../assets/icons/talent3.png"
import talent4 from "../../../assets/icons/talent4.png"

import styles from "./Specialist.scss"

const renderDetails = () => {
  return (
    <div id="imgs">
      <img src={talent1} alt="talent1" />
      <img src={talent2} alt="talent2" />
      <img src={talent3} alt="talent3" />
      <img src={talent4} alt="talent4" />
    </div>
  )
}

const renderBecomeSpecialist = () => {
  const { title, description } = becomeSpecialistText
  return (
    <div>
      <h1>{title}</h1>
      <hr />
      <span>{description}</span>
      {renderDetails()}
    </div>
  )
}

const renderGain = () => {
  const { title, gains } = gainText

  return (
    <div id="gain">
      <h1>{title}</h1>
      <hr />
      <div>
        {gains.map((gain: string) => (
          <div key={gain}>
            <img src={check} alt="check" />
            <span>{gain}</span>
          </div>
        ))}
      </div>
      <a
        href="https://allezgo.typeform.com/to/ai5zgM"
        target="_blank"
        rel="noopener noreferrer"
      >
        LANCEZ-VOUS !
      </a>
    </div>
  )
}

const renderGoals = () => {
  return (
    <div id="goals">
      {renderBecomeSpecialist()}
      {renderGain()}
    </div>
  )
}

const renderButtons = () => {
  return (
    <span id="buttons">
      <h1>Besoin de plus d'informations ?</h1>
      <span>N'hésitez pas à nous contacter !</span>
      <hr />
      <div id="contactMeans">
        <div>
          <div>
            <img src={logo} alt="logo" />
          </div>
          <div>
            <div>Par mail :</div>
            <a href="mailto:mickael.gomes2@gmail.com">
              mickael.gomes2@gmail.com
            </a>
            <div>Par téléphone au :</div>
            <span>09-99-99-99-99</span>
          </div>
        </div>
      </div>
    </span>
  )
}

const SpecialistPage = ({}: RouteComponentProps) => (
  <>
    <Navigation animated={false} />
    <div className={styles.container}>
      {renderGoals()}
      {renderButtons()}
    </div>
  </>
)

export default SpecialistPage
